"use client";
import { motion } from "framer-motion";
import { Star } from "lucide-react";

export default function Testimonials() {
  const testimonials = [
    {
      name: "Ahmed",
      location: "Dubai",
      rating: 5,
      text: "Just Gold made saving in gold incredibly simple. I started with just AED 50 and now have a growing portfolio. The app is intuitive and secure.",
      avatar: "/reviews/user1.svg",
    },
    {
      name: "Mohammed A",
      location: "Sharjah",
      rating: 5,
      text: "Being able to take physical delivery of my gold gave me complete confidence. The process was smooth and professional.",
      avatar: "/reviews/user2.svg",
    },
  ];

  return (
     <section className="py-12 px-4">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">
                {/* Left side - Header */}
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6 }}
                  className="lg:col-span-1"
                >
                  <div className="text-primary text-md mb-2">Testimonial</div>
                  <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-[#192839] leading-tight mb-4">
                    Trusted by Smart Investors Across the Globe
                  </h2>
                  <p className="text-[#57575c]">
                    Thousands use Just Gold to buy, store, and grow their gold with
                    confidence.
                  </p>
                </motion.div>
    
                {/* Right side - Testimonials */}
                <div className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-6">
                  {testimonials.map((testimonial, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ delay: index * 0.2, duration: 0.5 }}
                      className="bg-gray-100 rounded-xl p-6"
                    >
                      {/* User Info */}
                      <div className="flex items-center gap-3 mb-4">
                        <div className="flex items-center gap-3 mb-4">
                          <img
                            src={testimonial.avatar}
                            alt={testimonial.name}
                            className="w-12 h-12 rounded-full"
                          />
                          <div>
                            <div className="text-gray-900">{testimonial.name}</div>
                            <div className="text-[#57575c] text-md">{testimonial.location}</div>
                          </div>
                        </div>
                      </div>
    
                      {/* Rating */}
                      <div className="flex gap-1 mb-4">
                        {[...Array(testimonial.rating)].map((_, i) => (
                          <Star
                            key={i}
                            className="w-4 h-4 fill-yellow-400 text-yellow-400"
                          />
                        ))}
                      </div>
    
                      {/* Testimonial Text */}
                      <p className="text-gray-700 text-md leading-relaxed">
                        {testimonial.text}
                      </p>
                    </motion.div>
                  ))}
                </div>
              </div>
            </div>
          </section>
    
  );
}
